export default "__VITE_ASSET__DWQEa291__"